import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionCta } from './CtaButton';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="bg-cream px-4 py-16 sm:px-5 sm:py-20" aria-labelledby="volumes-title" data-id="element-272" data-mp="1lx4kzykg470w">
      <div className="mx-auto max-w-6xl" data-id="element-273" data-mp="1822asz8kfvia">
        <div className="mx-auto max-w-3xl text-center" data-id="element-274" data-mp="1c4p3f2d29kgj">
          <p className="text-sm font-extrabold tracking-wide text-teal" data-id="element-275" data-mp="1c3499duns3j7">INTRODUCING THE AAC CLINICAL BLUEPRINT™</p>
          <h2 id="volumes-title" className="mt-3 text-[28px] font-black leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-276" data-mp="24tw4o93wgo5h">
            Six Practical Volumes to Help You Organize Your AAC Planning Workflow
          </h2>
          <p className="mt-5 text-[17px] leading-relaxed text-muted" data-id="element-277" data-mp="1vsogwkz0f5pn">
            Rather than presenting isolated resources, this collection organizes key AAC planning topics into six complementary volumes. Each volume focuses on a distinct part of the educational planning process.
          </p>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-278" data-mp="3o97xuhpcsgqu">
          {volumes.map(v => <article key={v.number} className="flex flex-col overflow-hidden rounded-3xl border-l-[10px] bg-white p-6 shadow-card sm:p-7" style={{
          borderLeftColor: v.color
        }} data-id="element-279" data-mp="3ja559wqk82zr">
              <span className="w-fit rounded-lg px-3 py-1 text-sm font-black uppercase tracking-wide text-white" style={{
            backgroundColor: v.color
          }} data-id="element-280" data-mp="3t5yfh9gt3ked">
                Volume {v.number}
              </span>
              <h3 className="mt-4 text-[22px] font-black leading-tight text-ink" data-id="element-281" data-mp="krzmmgp4sf53">{v.title}</h3>
              <p className="mt-2 text-[16px] font-bold leading-snug" style={{
            color: v.color
          }} data-id="element-282" data-mp="frtoqis9pwek">{v.lead}</p>
              <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-283" data-mp="trcw39d993pt">{v.body}</p>
              <p className="mt-5 text-sm font-extrabold text-ink" data-id="element-284" data-mp="pqsv1upk9fye">Inside, you’ll find:</p>
              <ul className="mt-3 space-y-2.5" data-id="element-285" data-mp="wtzhcujucgc1">
                {v.items.map(item => <li key={item} className="flex gap-2.5 text-[15px] leading-snug text-ink/85" data-id="element-286" data-mp="11sty7qy8zuti">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0" style={{
                color: v.color
              }} strokeWidth={3} aria-hidden="true" data-id="element-287" data-mp="16rx4tftvm93l" />
                    {item}
                  </li>)}
              </ul>
            </article>)}
        </div>

        <p className="mt-10 text-center text-xl font-black text-ink sm:text-2xl" data-id="element-288" data-mp="1fjp9f9w7yo09">
          Six volumes. One organized educational reference collection.
        </p>
        <SectionCta label="Get all six volumes" data-id="element-289" data-mp="1pi52hiet47ce" />
      </div>
    </section>;
}